import React, { useState, useEffect } from "react";
import { Container, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader, Input, Col } from 'reactstrap';
import { Formik, Form, FieldArray } from "formik";
import { Loading } from '../../share/loading'
import * as Yup from 'yup'
import '../../share/form.css';
import Swal from 'sweetalert2'
import '../../SupportSystem/Reports/reportall.css';
import { NumberWithCommmas2 } from "../../share/NumberWithCommmas2";
import * as XLSX from "xlsx";

export function NewReportAllocatedAndSubsidies41Component() {
  const [data, setData] = useState([]);
  const [selectSupport, setSelectSupport] = useState([]);
  const [loading, setLoading] = useState(false);
  const user = JSON.parse(localStorage.getItem("userData"));
  const [openModal, setOpenModal] = useState(false);
  const ToggleModal = () => setOpenModal(!openModal);

  useEffect(() => {
    getdatafromview();
  }, []);

  async function getdatafromview() {
    setLoading(true);
    try {
      let res = await fetch("/api/SupportAllowcate/listAllocated41", {
        method: "POST",
        headers: { 'token': user.token },
      });
      const _data = await res.json();
      setData(_data.dataenum || []);
      setSelectSupport(
        (_data.dataenum || []).filter((v, i, arr) => arr.findIndex(v2 => (v2.supportId === v.supportId)) === i)
      );
    } catch (e) {
      console.log("err =>" + e);
    } finally {
      setLoading(false);
    }
  }

  // ---------- Utilities ----------
  const toNum = (v) => (v === null || v === undefined || v === "" ? "" : Number(v));
  const dval = (v) => (v === null || v === undefined || v === "" ? "-" : v);

  // group by supportId and compute merge flags per column (merge if all values are identical in that group)
  const groupBySupport = (rows) => {
    const map = new Map();
    const order = [];
    rows?.forEach(r => {
      const key = r.supportId;
      if (!map.has(key)) {
        map.set(key, []);
        order.push(key);
      }
      map.get(key).push(r);
    });

    return order.map((supportId, idx) => {
      const rowsInGroup = map.get(supportId);
      const rowspan = rowsInGroup.length;

      // keys mapping to underlying fields
      const keys = {
        supportNo: (x) => x.supportNo ?? null,
        createDate: (x) => x.createDate ?? null,
        supportName: (x) => x.supportName ?? null,
        letterNo: (x) => x.transferLetterNo ?? x.bookTransferNo ?? null, // ไม่มีในจอ -> จะออกเป็น "-" เหมือนกัน ก็ merge ได้
        fundDepositDate: (x) => x.fundDepositDate ?? null,               // ไม่มีในจอ -> "-"
        testReceiptDate: (x) => x.testReceiptDate ?? null,
        testLawOccupationName: (x) => x.testLawOccupationName ?? null,
        testOccupationName: (x) => x.testOccupationName ?? null,
        testPersonTotal: (x) => x.testPersonTotal ?? null,
        paymentAmountReq: (x) => x.paymentAmount ?? null,
        paymentAmountApproved: (x) => (x.paymentAmountApproved ?? x.paymentAmount ?? null),
      };

      const mergeFlags = {};
      Object.keys(keys).forEach(k => {
        const set = new Set(rowsInGroup.map(r => keys[k](r)));
        mergeFlags[k] = set.size <= 1; // true = ทุกแถวค่าเท่ากัน -> merge ได้
      });

      return { supportId, seq: idx + 1, rows: rowsInGroup, rowspan, mergeFlags };
    });
  };

  const groups = groupBySupport(data);

  // // ---------- XLSX export (header merge + body merge per group/column) ----------
  // const exportXlsxMerged41 = (rows) => {
  //   const groupsSelected = groupBySupport(rows);

  //   // Header (2 แถว): ให้ตรงกับ thead ที่หน้าเว็บ
  //   // index mapping (0-based)
  //   const COL = {
  //     SEQ: 0,
  //     SUPPORT_NO: 1,
  //     CREATE_DATE: 2,
  //     SUPPORT_NAME: 3,
  //     LETTER_NO: 4,
  //     FUND_DEPOSIT_DATE: 5,
  //     TEST_RECEIPT_DATE: 6,
  //     LAW_OCC: 7,
  //     OCC: 8,
  //     PERSON_TOTAL: 9,
  //     REQ_AMT: 10,
  //     APPROVED_AMT: 11,
  //   };

  //   const h0 = [
  //     "ที่", "เลขที่คำขอ", "วันที่รับคำขอ", "ชื่อผู้ขอรับเงินช่วยเหลือหรืออุดหนุน",
  //     "ประกาศข้อ 10", "", "", "", "", "", "",
  //     "จำนวนเงินที่อนุมัติ (บาท)"
  //   ];
  //   const h1 = [
  //     "", "", "", "",
  //     "เลขที่หนังสือที่แจ้งโอนเงินเข้ากองทุน (แบบสำเนาหนังสือ+ใบนำฝากเงิน)",
  //     "วันที่นำส่งเงินเข้ากองทุน (วัน/เดือน/ปี)",
  //     "วันที่ออกใบเสร็จรับเงิน ค่าทดสอบ/ค่าธรรมเนียม",
  //     "สาขาอาชีพ",
  //     "สาขา",
  //     "จำนวนคน",
  //     "จำนวนเงินที่ขอรับ (บาท)",
  //     "" // APPROVED_AMT (ถูก merge แนวตั้งจากแถวบน)
  //   ];

  //   const aoa = [h0, h1];

  //   // เติมข้อมูลตามคอลัมน์ 0..11
  //   groupsSelected.forEach(g => {
  //     g.rows.forEach((r, idx) => {
  //       aoa.push([
  //         idx === 0 ? g.seq : "",
  //         g.mergeFlags.supportNo ? (idx === 0 ? dval(r.supportNo) : "") : dval(r.supportNo),
  //         g.mergeFlags.createDate ? (idx === 0 ? dval(r.createDate) : "") : dval(r.createDate),
  //         g.mergeFlags.supportName ? (idx === 0 ? dval(r.supportName) : "") : dval(r.supportName),
  //         g.mergeFlags.letterNo ? (idx === 0 ? dval(r.transferLetterNo ?? r.bookTransferNo ?? "-") : "") : dval(r.transferLetterNo ?? r.bookTransferNo ?? "-"),
  //         g.mergeFlags.fundDepositDate ? (idx === 0 ? dval(r.fundDepositDate ?? "-") : "") : dval(r.fundDepositDate ?? "-"),
  //         g.mergeFlags.testReceiptDate ? (idx === 0 ? dval(r.testReceiptDate) : "") : dval(r.testReceiptDate),
  //         g.mergeFlags.testLawOccupationName ? (idx === 0 ? dval(r.testLawOccupationName) : "") : dval(r.testLawOccupationName),
  //         g.mergeFlags.testOccupationName ? (idx === 0 ? dval(r.testOccupationName) : "") : dval(r.testOccupationName),
  //         g.mergeFlags.testPersonTotal ? (idx === 0 ? toNum(r.testPersonTotal) : "") : toNum(r.testPersonTotal),
  //         g.mergeFlags.paymentAmountReq ? (idx === 0 ? r.paymentAmount : "") : r.paymentAmount,
  //         g.mergeFlags.paymentAmountApproved ? (idx === 0 ? r.paymentAmountApproved ?? r.paymentAmount : "") : r.paymentAmountApproved ?? r.paymentAmount,
  //       ]);
  //     });
  //   });

  //   const ws = XLSX.utils.aoa_to_sheet(aoa);

  //   // ความกว้างคอลัมน์
  //   ws["!cols"] = [
  //     { wch: 6 },   // 0
  //     { wch: 16 },  // 1
  //     { wch: 16 },  // 2
  //     { wch: 42 },  // 3
  //     { wch: 28 },  // 4
  //     { wch: 22 },  // 5
  //     { wch: 26 },  // 6
  //     { wch: 22 },  // 7
  //     { wch: 20 },  // 8
  //     { wch: 12 },  // 9
  //     { wch: 18 },  // 10
  //     { wch: 18 },  // 11
  //   ];

  //   // Merge หัวตาราง
  //   const merges = [
  //     // แถว 0: คอลัมน์ 0..3 แนวตั้งลงแถว 1
  //     { s: { r: 0, c: COL.SEQ }, e: { r: 1, c: COL.SEQ } },
  //     { s: { r: 0, c: COL.SUPPORT_NO }, e: { r: 1, c: COL.SUPPORT_NO } },
  //     { s: { r: 0, c: COL.CREATE_DATE }, e: { r: 1, c: COL.CREATE_DATE } },
  //     { s: { r: 0, c: COL.SUPPORT_NAME }, e: { r: 1, c: COL.SUPPORT_NAME } },
  //     // "ประกาศข้อ 10" แนวนอน 4..10 ที่แถว 0
  //     { s: { r: 0, c: COL.LETTER_NO }, e: { r: 0, c: COL.REQ_AMT } },
  //     // "จำนวนเงินที่อนุมัติ" แนวตั้ง 0..1
  //     { s: { r: 0, c: COL.APPROVED_AMT }, e: { r: 1, c: COL.APPROVED_AMT } },
  //   ];

  //   // Merge ตัวบอดี้: หลอมเฉพาะคอลัมน์ที่ค่าซ้ำทั้งกลุ่ม
  //   const headerRows = 2;
  //   let cur = headerRows;
  //   groupsSelected.forEach(g => {
  //     const start = cur;
  //     const end = cur + g.rowspan - 1;

  //     // ลำดับ (seq) รวมกลุ่มเสมอ
  //     if (g.rowspan > 1) merges.push({ s: { r: start, c: COL.SEQ }, e: { r: end, c: COL.SEQ } });

  //     // คอลัมน์ที่ merge หากค่าเหมือนกันทั้งกลุ่ม
  //     const mergeMap = [
  //       ["supportNo", COL.SUPPORT_NO],
  //       ["createDate", COL.CREATE_DATE],
  //       ["supportName", COL.SUPPORT_NAME],
  //       ["letterNo", COL.LETTER_NO],
  //       ["fundDepositDate", COL.FUND_DEPOSIT_DATE],
  //       ["testReceiptDate", COL.TEST_RECEIPT_DATE],
  //       ["testLawOccupationName", COL.LAW_OCC],
  //       ["testOccupationName", COL.OCC],
  //       ["testPersonTotal", COL.PERSON_TOTAL],
  //       ["paymentAmountReq", COL.REQ_AMT],
  //       ["paymentAmountApproved", COL.APPROVED_AMT],
  //     ];
  //     mergeMap.forEach(([k, c]) => {
  //       if (g.mergeFlags[k] && g.rowspan > 1) {
  //         merges.push({ s: { r: start, c }, e: { r: end, c } });
  //       }
  //     });

  //     cur = end + 1;
  //   });

  //   ws["!merges"] = merges;

  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "รายงานข้อ10");
  //   XLSX.writeFile(wb, "แบบขอรับการจัดสรร_ประกาศข้อ10.xlsx");
  // };

  // ✅ ใหม่: เรียก API ให้ฝั่ง .NET สร้างไฟล์ EPPlus แล้วดาวน์โหลด
  const downloadViaEpplus = async (supportIdAr) => {
    // ส่ง JSON (หรือจะใช้ FormData ก็ได้)
    let formData = new FormData();
    supportIdAr.forEach(item => formData.append("supportIds", item))

    const res = await fetch("/api/SupportAllowcate/exportAllocated41", {
      method: "POST",
      headers: {
        // 'Content-Type': 'application/json',
        'token': user.token
      },
      body: formData

      // body: JSON.stringify({ supportIds: selectedIds })
    });

    if (!res.ok) throw new Error("ไม่สามารถสร้างไฟล์ได้");

    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "แบบขอรับการจัดสรร_ประกาศข้อ10.xlsx"; // ชื่อไฟล์
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };


  const ExportSupport = async (values) => {
    setLoading(true);
    try {
      const picked = (values?.selectExportAr || []).filter(v => v.status);

      const selectedIds = values.selectExportAr.filter(x => x.status).map(x => x.supportId);
      if (!selectedIds.length) {
        setLoading(false);
        return;
      }
      // const rows = data.filter(d => selectedIds.includes(d.supportId));
      // exportXlsxMerged41(rows);
      // 1) ขอไฟล์จาก EPPlus แล้วดาวน์โหลด
      let formData = new FormData();
      let supportIdAr = Array.from(new Set(picked.map(p => p.supportId))).filter(Boolean);
      supportIdAr.forEach(item => formData.append("supportIds", item))
      await downloadViaEpplus(supportIdAr);

      // 7) อัปเดตสถานะหลังบ้าน (ส่ง supportId[])
      // console.log(supportIdAr)
      
      const updateRes = await fetch("/api/SupportAllowCate/updateStatusSupportAllocate", {
        method: "POST",
        body: formData

      });
      if (!updateRes.ok) throw new Error("อัปเดตสถานะไม่สำเร็จ");

      await Swal.fire({
        icon: "success",
        title: "ส่งออกสำเร็จ",
        text: "ได้ทำการอัปเดตสถานะเรียบร้อยแล้ว",
        confirmButtonColor: "#0A66C2",
        confirmButtonText: "ตกลง",
      });
    } catch (e) {
      console.log(e);
      Swal.fire({ icon: "error", title: "เกิดข้อผิดพลาดในการส่งออกไฟล์" });
    } finally {
      setLoading(false);
    }
  };

  const initialValues = {
    selectExportAr: selectSupport.map(item => ({
      supportId: item?.supportId,
      status: false,
    })),
  };

  const validateSchema = Yup.object().shape({});

  if (loading) return <Loading />;

  return (
    <Container>
      <center>
        <Label>
          แบบขอรับการจัดสรรเงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน ประจำปีงบประมาณ พ.ศ.
          {data?.length > 0 ? data[0]?.budgetYear : null}
        </Label>
      </center>
      <center><Label>ตามประกาศคณะกรรมการส่งเสริมการพัฒนาฝีมือแรงงาน</Label></center>
      <center>
        <Label>เรื่อง หลักเกณฑ์การใช้จ่ายเงินเพื่อช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน ลงวันที่ 31 มีนาคม พ.ศ. 2568</Label>
      </center>

      <div className="d-flex w-100 align-items-center justify-content-end mb-3">
        <button
          onClick={ToggleModal}
          disabled={!selectSupport.length}
          className="btn-green p-2 w-25"
        >
          Export Excel
        </button>
      </div>

      <div className="outer-wrapper">
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th rowSpan="2" className="text-center">ที่</th>
                <th rowSpan="2" className="text-center">เลขที่คำขอ</th>
                <th rowSpan="2" className="text-center">วันที่รับคำขอ</th>
                <th rowSpan="2" className="text-center">ชื่อผู้ขอรับเงินช่วยเหลือหรืออุดหนุน</th>
                <th colSpan="7" className="text-center">ประกาศข้อ 10</th>
                <th rowSpan="2" className="text-center">จำนวนเงินที่อนุมัติ<br />(บาท)</th>
              </tr>
              <tr>
                <th rowSpan="1" className="text-center">เลขที่หนังสือที่แจ้งโอนเงินเข้ากองทุน<br />(แบบสำเนาหนังสือ+ใบนำฝากเงิน)</th>
                <th rowSpan="1" className="text-center">วันที่นำส่งเงินเข้ากองทุน<br />(วัน/เดือน/ปี)</th>
                <th rowSpan="1" className="text-center">วันที่ออกใบเสร็จรับเงิน<br />ค่าทดสอบ/ค่าธรรมเนียม</th>
                <th className="text-center">สาขาอาชีพ</th>
                <th className="text-center">สาขา</th>
                <th className="text-center">จำนวนคน</th>
                <th rowSpan="1" className="text-center">จำนวนเงินที่ขอรับ<br />(บาท)</th>
              </tr>
            </thead>

            <tbody>
              {groups?.length ? (
                groups.map(g =>
                  g.rows.map((item, idx) => (
                    <tr key={`${g.supportId}-${idx}`}>
                      {/* ลำดับ: รวมกลุ่มเสมอ */}
                      {idx === 0 && <td rowSpan={g.rowspan} className="text-end">{g.seq}</td>}

                      {/* เลขที่คำขอ */}
                      {g.mergeFlags.supportNo
                        ? (idx === 0 && <td rowSpan={g.rowspan} className="text-end">{dval(item.supportNo)}</td>)
                        : <td className="text-end">{dval(item.supportNo)}</td>}

                      {/* วันที่รับคำขอ */}
                      {g.mergeFlags.createDate
                        ? (idx === 0 && <td rowSpan={g.rowspan} className="text-start">{dval(item.createDate)}</td>)
                        : <td className="text-start">{dval(item.createDate)}</td>}

                      {/* ชื่อผู้ขอรับเงินช่วยเหลือฯ */}
                      {g.mergeFlags.supportName
                        ? (idx === 0 && <td rowSpan={g.rowspan} className="text-start">{dval(item.supportName)}</td>)
                        : <td className="text-start">{dval(item.supportName)}</td>}

                      {/* เลขที่หนังสือแจ้งโอน */}
                      {g.mergeFlags.letterNo
                        ? (idx === 0 && <td rowSpan={g.rowspan} className="text-center">{dval(item.transferLetterNo ?? item.bookTransferNo ?? "-")}</td>)
                        : <td className="text-center">{dval(item.transferLetterNo ?? item.bookTransferNo ?? "-")}</td>}

                      {/* วันที่นำส่งเงินเข้ากองทุน */}
                      {g.mergeFlags.fundDepositDate
                        ? (idx === 0 && <td rowSpan={g.rowspan} className="text-center">{dval(item.fundDepositDate ?? "-")}</td>)
                        : <td className="text-center">{dval(item.fundDepositDate ?? "-")}</td>}

                      {/* วันที่ออกใบเสร็จรับเงิน */}
                      {g.mergeFlags.testReceiptDate
                        ? (idx === 0 && <td rowSpan={g.rowspan} className="text-start">{dval(item.testReceiptDate)}</td>)
                        : <td className="text-start">{dval(item.testReceiptDate)}</td>}

                      {/* สาขาอาชีพ */}
                      {g.mergeFlags.testLawOccupationName
                        ? (idx === 0 && <td rowSpan={g.rowspan} className="text-start">{dval(item.testLawOccupationName)}</td>)
                        : <td className="text-start">{dval(item.testLawOccupationName)}</td>}

                      {/* สาขา */}
                      {g.mergeFlags.testOccupationName
                        ? (idx === 0 && <td rowSpan={g.rowspan} className="text-start">{dval(item.testOccupationName)}</td>)
                        : <td className="text-start">{dval(item.testOccupationName)}</td>}

                      {/* จำนวนคน */}
                      {g.mergeFlags.testPersonTotal
                        ? (idx === 0 && <td rowSpan={g.rowspan} className="text-end">{dval(NumberWithCommmas2(item.testPersonTotal))}</td>)
                        : <td className="text-end">{dval(NumberWithCommmas2(item.testPersonTotal))}</td>}

                      {/* จำนวนเงินที่ขอรับ */}
                      {g.mergeFlags.paymentAmountReq
                        ? (idx === 0 && <td rowSpan={g.rowspan} className="text-end">{dval(item.paymentAmount)}</td>)
                        : <td className="text-end">{item.paymentAmount}</td>}

                      {/* จำนวนเงินที่อนุมัติ */}
                      {g.mergeFlags.paymentAmountApproved
                        ? (idx === 0 && <td rowSpan={g.rowspan} className="text-end">{dval(item.paymentAmountApproved ?? item.paymentAmount)}</td>)
                        : <td className="text-end">{dval(item.paymentAmountApproved ?? item.paymentAmount)}</td>}
                    </tr>
                  ))
                )
              ) : (
                <tr>
                  <td className="text-center" colSpan="12">ไม่มีข้อมูล</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <Modal
        isOpen={openModal}
        toggle={ToggleModal}
        backdrop={'static'}
        keyboard={false}
        size="xl"
        className="modal-bordered"
        centered
      >
        <Formik
          enableReinitialize
          initialValues={{
            selectExportAr: selectSupport.map((item) => ({
              supportId: item?.supportId,
              status: false,
            })),
          }}
          validationSchema={validateSchema}
          onSubmit={ExportSupport}
        >
          {({ values, handleChange, handleBlur, setFieldValue, handleSubmit }) => {

            const PreExport = () => {
              const pass = values.selectExportAr.some(el => el.status === true);
              if (!pass) {
                Swal.fire({
                  icon: "error",
                  title: "กรุณาเลือกอย่างน้อย 1 รายการ",
                  confirmButtonColor: "#0A66C2",
                  confirmButtonText: "ตกลง",
                })
              } else {
                Swal.fire({
                  icon: "info",
                  title: "ยืนยันการทำรายการหรือไม่ ?",
                  html: "หากยืนยันการทำรายการแล้ว <br/>จะไม่สามารถเลือกผู้ขอรับเงินช่วยเหลือหรืออุดหนุนเดิมได้",
                  confirmButtonColor: "#0A66C2",
                  confirmButtonText: "ตกลง",
                  showCancelButton: true,
                  cancelButtonText: "ยกเลิก",
                  cancelButtonColor: "#ff0000",
                }).then((result) => {
                  if (result.isConfirmed) {
                    handleSubmit(values);
                  }
                });
              }
            };

            return (
              <Form>
                <ModalHeader toggle={ToggleModal}>เลือกชื่อผู้ขอรับเงินช่วยเหลือหรืออุดหนุน</ModalHeader>
                <ModalBody>
                  <FieldArray name="selectExportAr">
                    {() => (
                      <div className="d-flex flex-column mt-3">
                        {selectSupport?.map((support, index) => (
                          <FormGroup row key={support.supportId ?? index}>
                            <Col>
                              <Label>
                                <Input
                                  type="checkbox"
                                  className="cus-type"
                                  name={`selectExportAr[${index}].status`}
                                  onBlur={handleBlur}
                                  onChange={(e) => {
                                    handleChange(e);
                                    setFieldValue(e.target.name, e.target.checked);
                                  }}
                                />
                              </Label>
                              <span className="ms-3">{support.supportName}</span>
                            </Col>
                          </FormGroup>
                        ))}
                      </div>
                    )}
                  </FieldArray>
                </ModalBody>
                <ModalFooter className="d-flex justify-content-center align-items-center">
                  <button
                    disabled={!selectSupport.length}
                    type="button"
                    onClick={PreExport}
                    className="btn-green p-2 w-25"
                  >
                    Export
                  </button>
                </ModalFooter>
              </Form>
            )
          }}
        </Formik>
      </Modal>
    </Container>
  );
}

// const validateSchema = Yup.object().shape({});
